// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card.contentcard ion-img.step {
  margin: 0 auto;
  width: 90px;
}
ion-card.contentcard ion-card.img-container ion-img {
  height: 150px;
}
ion-card.contentcard .otp-label {
  color: var(--ion-black-primary);
  font-size: 15px;
}
ion-card.contentcard form {
  margin: 0 auto;
  width: 90%;
}
ion-card.contentcard form .otp-box-wrapper {
  display: flex;
  justify-content: space-evenly;
}
ion-card.contentcard form .otp-box-wrapper .wrapm {
  padding: 2vw 1vw 1vw 1vw;
  position: relative;
  width: 10vw;
  height: 10vw;
  pointer-events: none;
}
ion-card.contentcard form .otp-box-wrapper input {
  padding: 2vw 1vw 1vw 1vw;
  text-align: center;
  position: absolute;
  font-size: 20px;
  font-weight: 700;
  color: var(--ion-black-primary);
  width: 10vw;
  height: 10vw;
  outline: none;
  top: 0;
  left: 0;
  pointer-events: auto;
  border: 0;
}
ion-card.contentcard form .otp-box-wrapper .d-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 10vw;
  height: 10vw;
}
ion-card.contentcard form .otp-box-wrapper ion-input {
  --padding-top: 10px;
  font-size: 20px;
  height: 50px;
  width: 50px;
  background-image: url('diet-box.png') !important;
}
ion-card.contentcard ion-col.resend-wrapper label {
  color: var(--ion-color-primary);
  font-weight: bold;
  font-size: 15px;
}
ion-card.contentcard ion-col.resend-wrapper span {
  color: var(--ion-black-primary);
  font-size: 15px;
}
ion-card.contentcard ion-col.timer-wrapper {
  margin-top: 10px;
}
ion-card.contentcard ion-col.timer-wrapper label {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: var(--ion-black-primary);
}
ion-card.contentcard ion-col.timer-wrapper span {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: var(--danger-false);
}
ion-card.contentcard ion-button {
  min-height: 45px;
  max-width: 225px;
  font-size: 18px;
  margin: 15% auto 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/otp-verification/otp-verification.page.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,WAAA;AAAR;AAIQ;EACI,aAAA;AAFZ;AAMI;EACI,+BAAA;EACA,eAAA;AAJR;AAOI;EACI,cAAA;EACA,UAAA;AALR;AAOQ;EACI,aAAA;EACA,6BAAA;AALZ;AAMA;EACI,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAJJ;AAMY;EACI,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;EACA,SAAA;AAJhB;AAUY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AARhB;AAWY;EACI,mBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gDAAA;AAThB;AAgBQ;EACI,+BAAA;EACA,iBAAA;EACA,eAAA;AAdZ;AAiBQ;EACI,+BAAA;EACA,eAAA;AAfZ;AAmBI;EACI,gBAAA;AAjBR;AAmBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;AAjBZ;AAoBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AAlBZ;AAsBI;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AApBR","sourcesContent":["ion-card.contentcard {\n    ion-img.step {\n        margin: 0 auto;\n        width: 90px;\n    }\n\n    ion-card.img-container {\n        ion-img {\n            height: 150px;\n        }\n    }\n\n    .otp-label {\n        color: var(--ion-black-primary);\n        font-size: 15px;\n    }\n\n    form {\n        margin: 0 auto;\n        width: 90%;\n\n        .otp-box-wrapper {\n            display: flex;\n            justify-content: space-evenly;\n.wrapm{\n    padding: 2vw 1vw 1vw 1vw;\n    position: relative;\n    width: 10vw;\n    height: 10vw;\n    pointer-events: none;\n}\n            input {\n                padding: 2vw 1vw 1vw 1vw;\n                text-align: center;\n                position: absolute;\n                font-size: 20px;\n                font-weight: 700;\n                color: var(--ion-black-primary);\n                width: 10vw;\n                height: 10vw;\n                outline: none;\n                top: 0;\n                left: 0;\n                pointer-events: auto;\n                border: 0;\n                //background-repeat: no-repeat !important;\n               // background-image: url(\"../../../assets/images/diet-box.svg\") !important;\n                \n                \n            }\n            .d-box {\n                position: absolute;\n                top: 0;\n                left: 0;\n                width: 10vw;\n                height: 10vw;\n            }\n\n            ion-input {\n                --padding-top: 10px;\n                font-size: 20px;\n                height: 50px;\n                width: 50px;\n                background-image: url(\"../../../assets/images/diet-box.png\") !important;\n                \n            }\n        }\n    }\n\n    ion-col.resend-wrapper {\n        label {\n            color: var(--ion-color-primary);\n            font-weight: bold;\n            font-size: 15px;\n        }\n\n        span {\n            color: var(--ion-black-primary);\n            font-size: 15px;\n        }\n    }\n\n    ion-col.timer-wrapper {\n        margin-top: 10px;\n\n        label {\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            color: var(--ion-black-primary);\n        }\n\n        span {\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            color:var(--danger-false);\n        }\n    }\n\n    ion-button {\n        min-height: 45px;\n        max-width: 225px;\n        font-size: 18px;\n        margin: 15% auto 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
